const commonAndMisc = {
  errorMessage404: "Ops! A página que você está procurando não existe", // translated
  backToHome: "Voltar para casa", // translated
  information: "Em formação", // translated
  additionalInformation: "informação adicional", // translated
  destinationPlaceholder: "Onde você está indo", // translated
  aboutUs: "Sobre nós", // translated
  pleaseWait: "Por favor, espere...", // translated
  featuredHotels: "Hotéis em destaque", // translated
  topPackages: "Principais pacotes", // translated
  topTours: "Principais passeios", // translated
  traveller: "Viajante", // translated
  reviews: "Avaliações", // translated
  home: "Casa", // translated
  packages: "Pacotes", // translated
  experiences: "Experiências", // translated
  close: "Perto", // translated
  loadingMessage: "Aguarde enquanto procuramos os melhores preços disponíveis", // translated
  loadingMessageTheHotelCo: "Aguarde enquanto procuramos os melhores preços disponíveis", // translated
  loadingMessageSearchStrip: "Aguarde enquanto procuramos os melhores preços disponíveis...", // translated
  topCountriesToVisit: "Principais países para visitar", // translated
  profile: "Perfil", // translated
  reservations: "Reservas", // translated
  address: "Endereço", // translated
  firstName: "Primeiro nome", // translated
  lastName: "Último nome", // translated
  email: "E-mail", // translated
  login: "Conecte-se", // translated
  logout: "Sair", // translated
  myProfile: "Meu perfil", // translated
  myChatRooms: "My Chats",
  chatRoomsListEmpty: "You have no chat rooms for this account.",
  chatRoomsOpen: "Open",
  chatRoomsLastActivity: "Last activity",
  chatRoomsUnread: "Unread",
  chatRoomsBadgeQuotation: "Quotation",
  chatRoomsBadgeTripOffer: "Trip offer",
  chatRoomsOpenQuotationAria: "Open quotation chat: {{name}}",
  chatRoomsOpenTripOfferAria: "Open trip offer chat: {{name}}",
  chatRoomsOpenGenericAria: "Open chat: {{name}}",
  quotationChatInvalidLink:
    "Invalid chat link. Open a chat from your profile or quotation list, or use exactly one of room_code or room_uid.",
  quotationChatNoTripDetails: "Trip details are not available for this chat.",
  chat: "Chat",
  verified: "Verificado", // translated
  unverified: "Não verificado", // translated
  selectLanguage: "Selecione o idioma", // translated
  selectCurrency: "Escolha a moeda", // translated
  upgrade: "Melhoria", // translated
  membership: "Filiação", // translated
  travelTrust: "Confiança de viagem", // translated
  signInUp: "Iniciar Sessão", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "hotéis e resorts em todo o mundo a preços incríveis de atacado", // translated
  dashboard: "Painel", // translated
  pricing: "Preços", // translated
  refundable: "Reembolsável", // translated
  cars: "Carros", // translated
  cruises: "Cruzeiros", // translated
  view: "Visualizar", // translated
  price: "Preço", // translated
  totalPrice: "Preço total", // translated
  filterRoomName: "Filtrar nome da sala", // translated
  get: "Obter", // translated
  guestInformationValidation: "Validação de informações do hóspede", // translated
  reservation: "Reserva", // translated
  checkIn: "Check-in", // translated
  checkOut: "Verificação de saída", // translated
  paymentInitiattionErroeMessage: "Não foi possível iniciar seu processo de pagamento. Lamentamos o inconveniente", // translated
  warning: "Aviso", // translated
  couldNotFindPriceForDateWarning: "Não foi possível encontrar um preço para esta data. Por favor, tente novamente para uma data diferente", // translated
  searchFormValidationError: "Erro de validação do formulário de pesquisa", // translated
  pleaseSelectValidDateFirst: "Selecione uma data válida primeiro", // translated
  searchError: "Erro de pesquisa", // translated
  priceSearchInitiationError: "Não foi possível iniciar o processo de pesquisa de preços. Por favor, tente novamente mais tarde. Lamentamos o inconveniente", // translated
  searchWarning: "Aviso de pesquisa", // translated
  couldNotFindPriceAndOrAvailability: "Não encontramos preço e/ou disponibilidade para sua solicitação. Lamentamos o inconveniente", // translated
  joinNow: "Entrar", // translated
  signIn: "Entrar", // translated
  searchNow: "Procure agora", // translated
  bookingFailed: "Falha na reserva", // translated
  sorryForTheInconvenience: "Lamentamos o inconveniente", // translated
  paymentFailedTryAgain: "Pagamento falhou. Por favor, tente novamente", // translated
  quickLinks: "Links Rápidos", // translated
  tours: "Passeios", // translated
  termsAndConditions: "Termos e Condições", // translated
  pleaseWaitWhileInitiatingPayment: "Aguarde enquanto iniciamos seu processo de pagamento", // translated
  back: "Costas", // translated
  nextStep: "Próxima Etapa", // translated
  book: "Livro", // translated
  checkout: "Confira", // translated
  specifyPickUpPoint: "Especifique o ponto de coleta de sua preferência", // translated
  pickupPoint: "Ponto de Recolha", // translated
  optional: "opcional", // translated
  remarks: "Observações", // translated
  travellerInformation: "Informações do viajante", // translated
  bookingRemarks: "Reservas Observações", // translated
  bookingOverview: "Visão geral da reserva", // translated
  paymentFailed: "Pagamento falhou", // translated
  paymentSuccess: "Sucesso do pagamento", // translated
  at: "Não", // translated
  person: "pessoa", // translated
  cancellationPolicy: "Política de cancelamento", // translated
  From: "A partir de", // translated
  to: "para", // translated
  cancellationIs: "cancelamento é", // translated
  pickup: "Escolher", // translated
  flights: "Voos", // translated
  Accommodation: "Alojamento", // translated
  payAndBook: "Pagar e reservar", // translated
  onRequest: "A pedido", // translated
  weAreFindingTheBestAvailableServices: "Estamos encontrando os melhores serviços disponíveis", // translated
  withTheBestAvailablePrices: "com os melhores preços disponíveis", // translated
  inRealTime: "em tempo real", // translated
  seconds: "segundos", // translated
  thisProcessCanTakeUpToOneMinute: "Esse processo pode levar até 1 minuto", // translated
  pleaseDoNotRefreshThisPage: "Por favor, não atualize esta página", // translated
  wellItSeemsItCanTakeBitLonger: "Bem... parece que pode demorar um pouco mais", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Seu navegador não suporta a tag de vídeo", // translated
  bookingSuccess: "Sucesso na reserva", // translated
  bookingReference: "Referência de reserva", // translated
  referenceCopied: "Referência copiada", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "Em breve você receberá um e-mail contendo todas as informações necessárias para sua reserva", // translated
  viewMore: "Veja mais", // translated
  readMore: "Consulte Mais informação", // translated
  customerSupport: "Suporte ao cliente", // translated
  socialMedia: "Mídia social", // translated
  hour: "hora", // translated
  star: "Estrela", // translated
  reference: "Referência", // translated
  sendUsRequest: "Envie-nos o seu pedido", // translated
  visitSite: "Visite o site", // translated
  nearby: "Próximo", // translated
  emailNotSentTryAgain: "E-mail não enviado! Por favor, tente novamente", // translated
  found: "Encontrado", // translated
  notAvailable: "Não disponível", // translated
  downloadVoucher: "Baixar comprovante", // translated
  cancelled: "Cancelado", // translated
  yourReservationIsInProgress: "Sua reserva está em andamento", // translated
  titleIsRequired: "O título é obrigatório", // translated
  hours: "horas", // translated
  applicationAvailable: "aplicativo disponível", // translated
  addressIsRequired: "Endereço é necessário", // translated
  cityIsRequired: "A cidade é obrigatória", // translated
  leadGuest: "Convidado principal", // translated
  noOptionsForSelectedFilters: "Não há opções disponíveis para combinar seus filtros", // translated
  restaurants: "Restaurantes", // translated
  progressAt: "Progresso em", // translated
  distanceFromSelection: "Distância da seleção", // translated
  sendUsEmail: "Envie-nos um e-mail", // translated
  security: "Segurança", // translated
  active: "Ativo", // translated
  lastNameIsRequired: "O sobrenome é obrigatório", // translated
  errorContentUnavailable: "Ops! O conteúdo que você procura não existe. Entre em contato conosco sobre o problema", // translated
  memberId: "ID de membro", // translated
  proceed: "Continuar", // translated
  firstNameIsRequired: "O primeiro nome é necessário", // translated
  phoneNumberIsRequired: "O número de telefone é obrigatório", // translated
  score: "Pontuação", // translated
  emailHasBeenSent: "E-mail enviado com sucesso", // translated
  emailIsRequired: "O e-mail é obrigatório", // translated
  currency: "Moeda", // translated
  lastNameMustContainAlphabetic: "O sobrenome deve conter apenas caracteres alfabéticos", // translated
  phoneNumberInTheFormat: "O número de telefone deve estar no formato sem espaços", // translated
  stars: "Estrelas", // translated
  sendCancellationEmail: "Enviar e-mail de cancelamento", // translated
  postalCodeIsRequired: "O código postal é obrigatório", // translated
  noReservationsForThisProduct: "Não há reservas para este produto", // translated
  clearYourFilters: "Limpe suas opções de filtro para ver os resultados", // translated
  confirmed: "Confirmado", // translated
  minutes: "minutos", // translated
  km: "quilômetros", // translated
  pending: "Pendente", // translated
  clickHere: "Clique aqui", // translated
  privacyPolicy: "política de Privacidade", // translated
  minute: "minuto", // translated
  pleaseCheckTheBox: "Marque a caixa para indicar que leu e concorda com as informações fornecidas antes de prosseguir para a próxima etapa.", // translated
  genderIsRequired: "O gênero é obrigatório", // translated
  sendUsYourRequest: "Envie-nos o seu pedido", // translated
  clearAllFilters: "Limpar todos os filtros", // translated
  sendVoucherEmail: "Enviar e-mail do voucher", // translated
  iHaveReadAgreeWithAbove: "Eu li e concordo com o acima", // translated
  invalidEmail: "E-mail inválido", // translated
  firstNameMustContainAlphabetic: "O primeiro nome deve conter apenas caracteres alfabéticos", // translated
  status: "Status", // translated
  countryIsRequired: "O país é obrigatório", // translated
  maintenanceTitle: "Site em manutenção",
  maintenanceDescription:
    "Estamos realizando uma manutenção programada. Volte em breve.",
  maintenanceCountdownLabel: "Tempo restante estimado",
  maintenanceLogoAlt: "Logotipo do site",
  maintenanceDays: "Dias",
  maintenanceHours: "Horas",
  maintenanceMinutes: "Minutos",
  maintenanceSeconds: "Segundos",
  maintenanceStatusBadge: "Manutenção programada",
  maintenanceRefresh: "Atualizar página",
  maintenanceExpired:
    "A manutenção deve ser concluída em breve. Atualize a página.",
};

export default commonAndMisc;
